<template>
  <div class="uploadFile_wrap" >
    <uploadList
      :list="fileList"
      :uploadType="uploadType"
      :uploadTitle="uploadTitle"
      :btnTitle="btnTitle"
      :accept="accept"
      :listW="listW"
      :listH="listH"
      :rowNum="rowNum"
      :multiple="multiple"
      :uploadSize="uploadSize"
      @search="search"
      @uploadFinsh="uploadFinsh"
      @uploadLocal="uploadLocal"
      :isUploadFlag="isUploadFlag"
      :addNumber="addNumber"
      :isAddSucaiFlag="isAddSucaiFlag"
      :iscustomFlag="iscustomFlag"
      :disabledFun="disabledFun"
      @select="selectList"
      v-loading="isLoading === 'noFullScreen'"
      element-loading-text="加载中" element-loading-spinner="el-icon-loading"
      ref="uploadList"
    >
    </uploadList>
    <Pagination
      @change="changeSize"
      v-model="searchObj.page"
      :total="total"
      ref="pagination"
      :pageSize="limit"
      v-if="Math.ceil(total / limit) > 1"
    ></Pagination>
    <div class="noData" v-if="fileList.length == 0 && !isUploadFlag">
      <img src="~@/assets/image/empty.png" alt="" />
    </div>
  </div>
</template>
<script>
import { mapActions,mapState } from "vuex";
import uploadList from "./uploadList.vue";
import Pagination from "../pagination/pagination.vue";
export default {
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    uploadType: {
      type: String,
      default: "video",
    },
    uploadTitle: {
      type: String,
      default: "点击上传本地视频",
    },
    btnTitle: {
      type: String,
      default: "播放",
    },
    accept: {
      type: Array,
      default: () => ['.mp4','.mov'],
    },
    addNumber: {
      type: Number,
      default: 1,
    },
    listW: {
      type: String,
      default: "240px",
    },
    listH: {
      type: String,
      default: "185px",
    },
    rowNum: {
      type: Number,
      default: 4,
    },
    limit: {
      type: Number,
      default: 10,
    },
    isUploadFlag: {
      type: Boolean,
      default: true,
    },
    uploadSize: {
        type: String,
        default: '300mb'
    },
    isAddSucaiFlag: {
        type: Boolean,
        default: true
    },
    iscustomFlag: {
      type: Boolean,
      default: false
    },
    disabledFun: {
      type: Function,
      default: () => false
    }
  },
  data() {
    return {
      searchObj: {
        keywords: "",
        page: 1,
      },
      fileTypeObj: {
        img: 1,
        video: 2,
        audio: 3,
      },
      fileList: [],
      total: 0,
      selectValue: [],
    };
  },
  components: {
    uploadList,
    Pagination,
  },
  computed: {
    ...mapState(['isLoading'])
  },
  created() {
    this.getMaterialIndex();
  },
  methods: {
    ...mapActions("uploads", ["materialIndex"]),
    async getMaterialIndex() {
      let res = await this.materialIndex({
        ...this.searchObj,
        limit: this.limit,
        type: this.fileTypeObj[this.uploadType],
      });
      this.total = res.count;
      this.fileList = res.data.map((item) => {
        return {
          name: item.origin_name + "." + item.material_extension,
          duration: item.material_time,
          material_size: item.material_size,
          url: item.material_url,
          id: item.id,
          fileType: item.type,
          vertically: item.vertically,
          suffix: "." + item.material_extension
        };
      });
      if (!this.isUploadFlag) {
        let objList = this.selectValue.flat(1).map(item => item.id) || [];
        this.fileList.forEach((item) => {
          if (objList.includes(item.id)) {
            item.checked = true;
          }
        });
      }
    },
    search(value) {
      this.searchObj.keywords = value;
      this.getMaterialIndex();
    },
    uploadFinsh() {
      this.getMaterialIndex();
    },
    changeSize(value) {
      this.searchObj.page = value;
      this.getMaterialIndex();
    },
    clearSelectList(list) {
      this.selectValue= list
      this.$emit("select", list)
    },
    selectList(list) {
	  let select = JSON.parse(JSON.stringify(list))
	  
      if(this.multiple) {
        this.selectValue[this.searchObj.page] = select;
		    select = this.selectValue.flat(1)
      }  else{
        this.selectValue = select
      }
	  if(select.length){
	  	select.forEach((item) => {
			const randomString = this.randomString(6)
	  		const t= Date.now()+'_'+ randomString
	  		if(item.fileType == 2 || item.fileType == 3){
	  			item.url = item.url +'?timestamp=' + t 
	  		} else {
	  			item.url = item.url +'&timestamp=' + t 
	  		}
	  	});
	  }
	  this.$emit("select",select)
    },
	randomString(len) {    
	    len = len || 8;
	    let t = "abcdefghijkmnpqrstuvwxyz23456789",
	    a = t.length,
	    n = "";
	    for (let i = 0; i < len; i++) n += t.charAt(Math.floor(Math.random() * a));
	    return n
	},
    uploadLocal() {
      this.$emit('uploadLocal')
    }
  },
};
</script>
<style lang="less" scoped>
.uploadFile_wrap {
  min-height: 500px;
}
.noData {
  width: 50%;
  height: 100%;
  margin: 50px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
  }
}
</style>
